import React, { useEffect, useState } from 'react';

const NAV_LINKS = [
  // { label: 'Home', href: '/' },
  // { label: 'About Us', href: '/about' },
  { label: 'AI & Data', href: '/ai-and-data' },
  { label: 'Engineering', href: '/engineering' },
  { label: 'Find Talent', href: '/hire-tech-team' },
  { label: 'Success Stories', href: '/success-stories' },
  { label: 'Join Us', href: '/join-us' },
];

const Logo = ({ scrolled }: { scrolled: boolean }) => (
  <a href="/" className="flex items-center transition-all duration-500">
    <img
      src="/Images/Brand-Logo/1.png"
      alt="Akwid Labs"
      className={`w-auto transition-all duration-500 ${scrolled ? 'h-7 md:h-9' : 'h-8 md:h-9'}`}
    />
  </a>
);

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <>
      {/* Header */}
      <header
        className={`fixed left-1/2 top-4 z-50 w-full -translate-x-1/2 px-2 transition-[max-width,backdrop-filter] duration-700 ease-[cubic-bezier(0.16,1,0.3,1)] md:px-0 ${
          scrolled
            ? 'max-w-full backdrop-blur-xl md:max-w-6xl'
            : 'max-w-full backdrop-blur-md md:max-w-7xl md:px-3'
        } `}
      >
        <nav
          className={`relative flex items-center justify-between overflow-hidden rounded-full border border-purple-500/20 bg-gradient-to-r from-[#090014]/85 via-[#1a0f2e]/85 to-[#12071f]/85 transition-all duration-700 ${
            scrolled
              ? 'px-3 py-1.5 shadow-[0_6px_25px_rgba(126,34,206,0.25)] md:px-4 md:py-1.5'
              : 'px-4 py-2 shadow-[0_12px_40px_rgba(126,34,206,0.35)] md:px-5 md:py-2'
          } `}
        >
          {/* Animated glow */}
          <div className="pointer-events-none absolute inset-0">
            <div className="animate-slowFloat absolute -left-20 -top-16 h-56 w-56 rounded-full bg-purple-600/20 blur-3xl" />
            <div className="animate-slowFloat2 absolute right-0 top-8 h-40 w-40 rounded-full bg-pink-500/15 blur-3xl" />
          </div>

          <Logo scrolled={scrolled} />

          {/* Desktop Nav */}
          {/* Desktop Nav */}
          <div className="relative hidden items-center gap-7 text-sm font-medium text-gray-200 md:flex">
            {NAV_LINKS.map(({ label, href }) => {
              const isActive = window.location.pathname === href; // mark active
              return (
                <a
                  key={label}
                  href={href}
                  className={`group relative transition-colors ${
                    isActive ? 'text-purple-400' : 'text-gray-200'
                  } hover:text-purple-400`}
                >
                  {label}
                  <span
                    className={`absolute -bottom-1 left-0 h-[2px] w-0 bg-gradient-to-r from-purple-400 via-pink-400 to-purple-400 transition-all duration-300 ${
                      isActive ? 'w-full' : 'group-hover:w-full'
                    }`}
                  />
                </a>
              );
            })}

            <a
              href="/contacts"
              className={`rounded-full px-4 py-2 text-white transition-all duration-300 hover:scale-105 ${
                scrolled
                  ? 'bg-gradient-to-r from-pink-700 to-purple-700 hover:shadow-[0_0_18px_rgba(168,85,247,0.8)]'
                  : 'bg-gradient-to-r from-purple-600 to-pink-600 hover:shadow-[0_0_18px_rgba(168,85,247,0.6)]'
              }`}
            >
              Contact
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setMenuOpen((v) => !v)}
            className="relative z-10 p-1 md:hidden"
            aria-label="Toggle menu"
          >
            <svg
              className="h-6 w-6 text-gray-200 transition-colors hover:text-purple-400"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              {menuOpen ? (
                <path strokeWidth="2" strokeLinecap="round" d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeWidth="2" strokeLinecap="round" d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </nav>
      </header>

      {/* Mobile Dropdown */}
      {menuOpen && (
        <div className="fixed left-1/2 top-[5.5rem] z-40 w-[92%] max-w-md -translate-x-1/2 rounded-2xl border border-purple-500/20 bg-gradient-to-br from-[#090014]/95 via-[#1a0f2e]/95 to-[#12071f]/95 p-6 shadow-[0_15px_40px_rgba(126,34,206,0.4)] backdrop-blur-xl md:hidden">
          <div className="flex flex-col gap-5 text-gray-200">
            {NAV_LINKS.map(({ label, href }) => (
              <a
                key={label}
                href={href}
                onClick={() => setMenuOpen(false)}
                className="text-lg transition-colors hover:text-purple-400"
              >
                {label}
              </a>
            ))}

            <a
              href="/contact"
              onClick={() => setMenuOpen(false)}
              className="mt-2 rounded-full bg-gradient-to-r from-purple-600 to-pink-600 px-4 py-2 text-center text-white transition hover:scale-105"
            >
              Contact Us
            </a>
          </div>
        </div>
      )}
    </>
  );
}
